// @codekit-prepend "../../node_modules/jquery/dist/jquery.js";
// @codekit-prepend "../../node_modules/foundation-sites/dist/js/foundation.min.js";
// @codekit-prepend "../../node_modules/aos/dist/aos.js";

jQuery(function ($) {

	// Call the pretty Foundation scripts
	$(document).foundation();

	// AOS initilisation for Location block
  	AOS.init({
		duration: 500,
		easing: 'linear',
		once: true,
	});

	// Make the entire div containing link clickable.
	$(".link-box").on( 'click', function(){
		if($(this).find("a").length){
	       window.location.href = $(this).find("a:first").attr("href");
	       var $a = $(this).find("a:first");
	       window.open($a.attr("href"), $a.attr("target") || '_self');
	       return false;
		}
	});

	// Insert screen reader text for pagination on archive pages.
	$(".page-numbers a:not(.next)").each(function() {
		$(this).prepend('<span class="sr-only">Page number </span>');
	});

	// Add aria-labels to required form fields
	$('.frm_required').each(function() {
		$(this).parent().attr('aria-label', 'This is a required field');
		$(this).text('* (required)');
	})

	/*****
	 * Alert Banner
	*******/

	// Get current time.
	var currentTime = new Date().getTime();

	// Add hours function.
	Date.prototype.addHours = function(h) {    
		this.setTime( this.getTime() + ( h*60*60*1000) ); 
		return this;   
	}

	// Get time after 24 hours.
	var after24 = new Date().addHours(10).getTime();

	// Hide alert banner on click.
	$( '.site-alert__close' ).on('click', function() {
		$(this).closest( '.site-alert' ).fadeOut();
		localStorage.setItem( 'desiredTime', after24 ); 
	});

	// Show / Hide alert base on time.
	if( localStorage.getItem( 'desiredTime' ) >= currentTime ) {
		$( '.site-alert' ).addClass( 'hide' );
	} else {
		$( '.site-alert' ).removeClass( 'hide' );
	}
});
